<template>
  <div class="statusBar">

<!--    <statusKo></statusKo>-->

    <h3>Статус звонка:</h3>
    <ul id="main_status">
      <li v-for="item in availabelStatusList">
        <label v-bind:style="item.bg">
          <input type="radio" v-model="CallStatus" :value="item.name">
          <span>{{item.name}}</span>
        </label></li>
    </ul>
    <div v-if="subStatusList.length > 0">
      <h3>Уточнение статуса:</h3>
      <ul>
        <li v-for="item in subStatusList">
          <label v-bind:style="item.bg">
            <input type="radio" v-model="SubCallStatus" :value="item.name">
            <span>{{item.name}}</span>
          </label>
        </li>
        <li class="forTimeLi" v-show="showTimeForm">
          <formInput :refs="'ReCallDate'" :form="'status'"></formInput>
        </li>
        <li class="forTimeLi" v-show="showTimeForm">
          <formInput :refs="'ReCallTime'" :form="'status'"></formInput>
        </li>
      </ul>
    </div>

    <div id="pdlKostil" v-show="pdlKostilPaymentDay">
      <p>Планируемая дата платежа</p>
      <input type="date" v-model="dateKostilReCallDate">
    </div>

    <div
      class="v-recurrent-show"
      v-show="showRecurrent"
    >
      <VRecurrent
        :PdlData="PdlData"
      />

    </div>

    <div>
      <h3>Примечание к звонку:</h3>
      <textarea v-model="OperatorMsg"></textarea>
    </div>
    <div v-if="canSaveStatus">
      <div class="button" v-on:click="saveStatus(false)">Зарегистрировать звонок</div>
      <div class="button" v-on:click="saveStatus(isAutoForm)" v-if="isAutoForm">Зарегистрировать звонок и
        поставить на паузу</div>
    </div>
  </div>
</template>

<script>
//todo дообавить поля перезвона, с датой и временем
  import StatusListLib from '@/gavnoCode/statusList';
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "statusBar",
    components:{
      VRecurrent: () => import('@/components/payments/VRecurrent'),
      // statusKo: () => import('@/components/status/statusKo'),
      formInput: () => import('@/components/forms/formInput'),
    },
    props: {
      PdlData:{
        type:Object,
			  default () {
				  return {}
			  },
      },
      typeCall: {
        type: String,
        default: ''
      }
    },
    data: function () {
      return {
        statusList: StatusListLib.StatusListOutgoing,
        subStatusList: [],
        showTimeForm: false,
        isAutoForm:false
      }
    },
    methods: {
      saveStatus:function(isAutoForm){
        let SendData = {
          data:Object.assign({}, this.valueVuex),
          action:'Operator_saveStatus'
        };
        this.$store.commit('setContent', 'Сохранение звонка, ожидайте');
        this.$store.commit('showModal');

        this.$myApi.SendRequest(SendData, this, 'saveStatus', true).then((result) => {
          this.$store.commit('hideModal');
          if (isAutoForm) {
            this.$emit('loadNewLeadWithPause');
          } else {
            this.$emit('loadNewLead');
          }
        }).catch((msg) => {
          this.$store.commit('setContent', msg);
          this.$store.commit('showModal');
        });
      },
      chekIssetSubStatus: function (item) {
        if (item.subStatus) {
          return true;
        } else {
          return false;
        }
      },
      returnStatusObject: function(value){
        //поиск объекта по значению
        let thisStatus = this.availabelStatusList.filter(item => {
          if (item.name == value) {
            return true;
          }
        });
          if(thisStatus.length === 1) {
            return thisStatus[0];
          } else {
            return [];
          }
      },
      selectedStatusObject: function (element, index) {
        if (element.name == this.CallStatus) {
          return element;
        }
      },
      setRecallDateTime: function () {

        let date = new Date(new Date().getTime());
        let day = date.getDate();
        let month = (date.getMonth() + 1) < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        day = day < 10 ? '0' + day : day;
        let h = date.getHours() < 9 ? '0' + (date.getHours() + 1) : (date.getHours() + 1);
        let m = date.getMinutes() < 9 ? '0' + (date.getMinutes() + 1) : (date.getMinutes() + 1);
        let recallDate = {
          ReCallDate: date.getFullYear() + '-' + month + '-' + day,
          ReCallTime: h + ':' + m
        };
        this.$store.dispatch('setRequestField', {
          values: recallDate,
          form: 'status'
        });
      },
      clearRecallTime: function () {
        let recallDate = {
          ReCallDate: '',
          ReCallTime: ''
        };
        this.$store.dispatch('setRequestField', {
          values: recallDate,
          form: 'status'
        });
      }
    },
    watch: {
      showTimeForm: function (value) {
        if (value) {
          this.setRecallDateTime();
        } else {
          this.clearRecallTime();
        }

      },
      CallStatus: function (value) {
        //смотрим на выбранный статус, если есть доп статусы показываем их, если заявка, то показываем форму
        let thisStatus = this.returnStatusObject(value);
        // console.log(thisStatus);
        this.SubCallStatus = ' ';
        if (this.chekIssetSubStatus(thisStatus)) {
          // console.log(this.chekIssetSubStatus(thisStatus))
          this.subStatusList = thisStatus.subStatus;
        } else {
          // console.log('--')
          this.subStatusList = [];
        }
      },
    },
    computed: {
      showRecurrent () {
        return this.isPDL;
      },
      pdlKostilPaymentDay(){
        return this.isPDL && this.valueVuex['status']['CallStatus'] == 'Планирует внести платеж';
      },
      dateKostilReCallDate: {
        get() {
          return this.valueVuex['status']['ReCallDate'];
        },
        set(value) {
          this.$store.dispatch('saveSendData',{
            target:'ReCallDate',
            form:'status',
            value: value
          });
        }
      },
      canSaveStatus: function () {
        //проверяем есть ли возможность сохранить звонок без заявки
        let xz = {};



        // if (this.valueVuex['LeadInfo']['LeadType'] == 'КО') {
        //   if (!this.canSaveKo) return false;
        // }

        if (this.CallStatus.length > 0){
          if (this.CallStatus == 'Оформлена заявка') {
            return false;
          }
          xz = this.availabelStatusList.find(this.selectedStatusObject);
          if (xz.subStatus != undefined) {
            if (this.SubCallStatus.length > 1) {
              return true
            }
          } else {
            return true;
          }
        }


        return false;
      },
      availabelStatusList: function () {
        let statusGroup = this.isPDL ? 'StatusListPDL' : 'StatusListOutgoing';
        return StatusListLib[statusGroup];
      },
      CallStatus:{
        get(){
          if (this.valueVuex['status']['CallStatus'] == 'Перезвонить' ||
            this.valueVuex['status']['CallStatus'] == 'Планирует внести платеж'
          ) {
            this.showTimeForm = true;
          } else {
            this.showTimeForm = false;
          }
          return this.valueVuex['status']['CallStatus'];
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'CallStatus',
            form:'status',
            value: value
          });
        }
      },
      SubCallStatus: {
        get(){
          return this.valueVuex['status']['SubCallStatus']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'SubCallStatus',
            form:'status',
            value: value
          });
        }
      },
      OperatorMsg: {
        get(){
          return this.valueVuex['status']['OperatorMsg']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'OperatorMsg',
            form:'status',
            value: value
          });
        }
      },
      ...mapGetters(['canSaveKo','isPDL']),
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData,
      })
    },
    mounted: function () {
      //this.isAutoForm = this.$route.path == '/autoCC';
    }
  }
</script>

<style>
  .v-recurrent-show--not-found {
    padding: 20px 0;
    font-size: 20px;
    font-weight: bolder;
    color: red;
  }

  .statusBar {
  }

  .statusBar ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
  }

  .statusBar ul li {
    width: 16%;
    min-height: 45px;
    margin: 3px 0.8% 3px 0;
  }
  .statusBar ul li:nth-child(6n) {margin-right: 0;}

  .statusBar ul li label {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    justify-content: flex-start;
    text-align: left;
  }

  .statusBar ul li label:hover {
    background: rgba(15, 87, 64, 0.11);
    box-shadow: 1px 2px 6px 4px rgba(11, 58, 15, 0.66);
  }

  .statusBar ul li label input {
    width: 20px;
  }

  .statusBar ul li label span {
    font-size: 15px;
    line-height: 0.8;
    width: calc(100% - 30px);
  }

  textarea {
    width: calc(100% - 2px - 10px);
    height: 80px;
    border: 1px solid rgb(15, 87, 64);
  }

  .statusBar ul li.forTimeLi {
    width: 20%;
  }
</style>
